import React, { Fragment, useState, useEffect, useRef } from "react";
import Volume from "./Volume";

const LiveJobsFeature = () => {
  const videoRef = useRef(null);
  const [duration, setDuration] = useState(0);
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateDuration = () => {
      setDuration(video.duration);
    };
    video.addEventListener("loadedmetadata", updateDuration);

    return () => video.removeEventListener("loadedmetadata", updateDuration);
  }, [setDuration]);
  return (
    <Fragment>
      <div className="current-feature">
        <img
          src={"https://ime.sfo3.cdn.digitaloceanspaces.com/img/employer.jpg"}
          className="live-image-container"
        />
        <div className="middle-container blue">
          <div className="stream-content">
            <div className="top-video-overlay">
              <div className="user-overlay-info">
                <div className="top-user-avi-container">
                  <div className="streamer-user-avi"></div>
                </div>
                <div className="helper-container">
                  <div className="stream-description-alt">
                    <p className="stream-username-title">
                      <span className="blue description-font mr-10">
                        EmployerName
                      </span>
                      <span className="white mr-5 description-font-alt">
                        FirstName
                      </span>
                      <span className="white description-font-alt">
                        LastName
                      </span>
                    </p>
                    <p className="stream-p-description">
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Nam ratione aut eaque dolor ea temporibus laboriosam
                      laborum recusandae odio omnis.
                    </p>
                  </div>
                </div>
              </div>
              <div className="video-stream-live blue">
                <i className="fas fa-circle mx-5"></i>
                Live
              </div>
              <div className="alt-left-controls">
                <ul className="controls">
                  <Volume
                    className="Rac__volume"
                    initial={0}
                    onChange={(level) => {
                      const volume = level / 100;
                      videoRef.current.volume = volume;
                      videoRef.current.muted = volume === 0;
                    }}
                  />
                </ul>
              </div>
              <div className="watch-stream">
                <ul>
                  <li className="watch-stream-item white">Employer Name</li>
                  <li className="watch-stream-item white">Job Position</li>
                  <li className="watch-stream-item white">Location</li>
                </ul>
                <button className="watch-stream-button background-blue">
                  Watch
                </button>
              </div>
              <div className="stream-viewers-right white">
                <i className="fas fa-user mx-5"></i>
                82.7k
              </div>
            </div>
            <video
              ref={videoRef}
              muted={true}
              src={
                "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/discussion_two.mp4"
              }
              autoPlay={true}
              loop={true}
              className="top-stream-video fill-video"
            ></video>
          </div>
        </div>
        <img
          src={"https://ime.sfo3.cdn.digitaloceanspaces.com/img/employer.jpg"}
          className="live-image-container"
        />
      </div>
    </Fragment>
  );
};

export default LiveJobsFeature;
